import React, { useContext } from "react";
import './SideMenu.css';
import '../../../../assets/sideMenu/icons.css';
import { signOutUser } from "../../../../api/api";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../../appContext";

interface ISideMenuProps{
    onSelect: (name: string)=> void;
    selected: string;
}

export const SideMenu = ({onSelect, selected}: ISideMenuProps)=>{
    const {translate, user} = useContext(AppContext);
    const navigate = useNavigate();
    const {isAdmin} = useContext(AppContext);

    return <div className={`dashboardSideMenu`}>
        <div className="dashboardSideMenu_up">
            <div className="dashboardSideMenu_group">
                <div className="button dashboardSideMenu_button icons_sideMenu_account" 
                    onClick={()=>onSelect('profile')}
                >
                    {translate('sideMenu_profile')}
                </div>
                {isAdmin === true && (
                    <div className="button dashboardSideMenu_button icons_sideMenu_crown"
                        onClick={()=>onSelect('administrator')}
                    >
                        {translate('sideMenu_administrator')}
                    </div>
                )}
            </div>
            <div className="dashboardSideMenu_group">
                <div className="button dashboardSideMenu_button icons_sideMenu_settings"
                    onClick={()=>onSelect('privacy')}
                >
                    {translate('sideMenu_privacy')}
                </div>
                <div className="button dashboardSideMenu_button icons_sideMenu_language"
                    onClick={()=>onSelect('language')}
                >
                    {translate('sideMenu_language')}
                </div>
                <div className="button dashboardSideMenu_button icons_sideMenu_quickstart"
                    onClick={()=>onSelect('quickstart')}
                >
                    {translate('sideMenu_quickstart')}
                </div>
            </div>
            <div className="dashboardSideMenu_group">
                <div className="button dashboardSideMenu_button icons_sideMenu_faq"
                    onClick={()=>onSelect('faq')}
                >
                    {translate('sideMenu_faq')}
                </div>
                <div className="button dashboardSideMenu_button icons_sideMenu_settings"
                    onClick={()=>onSelect('settings')}
                >
                    {translate('sideMenu_settings')}
                </div>
                </div>
        </div>
        <div className="dashboardSideMenu_down">
            <div className="dashboardSideMenu_group">
                <div className="button dashboardSideMenu_button icons_sideMenu_logout" onClick={()=>{
                    signOutUser().then(()=>{
                        navigate('/login');
                    });
                }}>
                    {translate('sideMenu_logout')}
                </div>
            </div>
        </div>
    </div>
}